import {
  AppBar,
  Box,
  Grid,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from '@mui/material';
import { Layout } from 'components';
import { drawerWidth } from 'config';
import { SETTING_TAB } from 'models';
import React, { useState } from 'react';
import Accounts from './Accounts';
import Badges from './Badges';
import Certificates from './Certificates';
import ChatKeywordTracking from './ChatKeywordTracking';
import Concierge from './Concierge';
import General from './General';
import JobsAndSitters from './JobsAndSitters';
import ManageAppVersion from './ManageAppVersion';
import OTPBlacklist from './OTPBlacklist';
import ReasonForReportingUser from './ReasonForReportingUser';
import Regions from './Regions';
import Review from './Review';
import Surcharge from './Surcharge';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`sitter-detail-tabpanel-${index}`}
      aria-labelledby={`sitter-detail-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `sitter-detail-tab-${index}`,
    'aria-controls': `sitter-detail-tabpanel-${index}`,
  };
}

const tabs: string[] = [
  SETTING_TAB.GENERAL,
  SETTING_TAB.ACCOUNTS,
  SETTING_TAB.GOOGLE_REVIEW,
  SETTING_TAB.JOBS_AND_SITTERS,
  SETTING_TAB.CONCIERGE,
  SETTING_TAB.SURCHARGE_AC,
  SETTING_TAB.REPORTING,
  SETTING_TAB.BADGES,
  SETTING_TAB.CERTIFICATES,
  SETTING_TAB.REGIONS,
  SETTING_TAB.MANAGE_APP_VERSION,
  SETTING_TAB.CHAT_KEYWORD_TRACKING,
  SETTING_TAB.OTP_BLACKLIST,
];

const Settings = () => {
  const [tabValue, setTabValue] = useState<number>(0);

  const handleChangeTabValue = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <AppBar
        position="fixed"
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
          backgroundColor: 'white.light',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Grid>
            <Typography
              sx={{
                fontSize: '20px',
                lineHeight: 1,
                color: 'grey1.light',
              }}
            >
              Settings
            </Typography>
          </Grid>
        </Toolbar>
      </AppBar>
      <Paper elevation={0} sx={{ p: '16px' }}>
        <Grid
          container
          sx={{
            borderBottom: '1px solid  rgba(0, 0, 0, 0.08)',
            marginBottom: '16px',
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((item, index) => {
              return (
                <Tab
                  key={index}
                  label={item}
                  sx={{
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '125%',
                    letterSpacing: '0.1px',
                    color: '#959595',
                    textTransform: 'capitalize',
                  }}
                  {...a11yProps(index)}
                />
              );
            })}
          </Tabs>
        </Grid>
        <TabPanel value={tabValue} index={0}>
          <General />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Accounts />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <Review />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <JobsAndSitters />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <Concierge />
        </TabPanel>
        <TabPanel value={tabValue} index={5}>
          <Surcharge />
        </TabPanel>
        <TabPanel value={tabValue} index={6}>
          <ReasonForReportingUser />
        </TabPanel>
        <TabPanel value={tabValue} index={7}>
          <Badges />
        </TabPanel>
        <TabPanel value={tabValue} index={8}>
          <Certificates />
        </TabPanel>
        <TabPanel value={tabValue} index={9}>
          <Regions />
        </TabPanel>
        <TabPanel value={tabValue} index={10}>
          <ManageAppVersion />
        </TabPanel>
        <TabPanel value={tabValue} index={11}>
          <ChatKeywordTracking />
        </TabPanel>
        <TabPanel value={tabValue} index={12}>
          <OTPBlacklist />
        </TabPanel>
      </Paper>
    </Layout>
  );
};

export default Settings;
